export enum InternalTransferTypeEnum {
  ENTIRE_ACCOUNT = 'ENTIRE_ACCOUNT',
  PARTIAL = 'PARTIAL',
  UNKNOWN = 'UNKNOWN',
}

export enum InternalTransferMethodEnum {
  SHARES = 'SHARES',
  PERCENT = 'PERCENT',
  DOLLARS = 'DOLLARS',
  UNKNOWN = 'UNKNOWN',
}

export enum InternalTransferMethodDisplayEnum {
  SHARES = 'Shares',
  PERCENT = 'Percent',
  DOLLARS = 'Dollars',
  UNKNOWN = 'Unknown',
}
export const InternalTransferMethodEnumToDisplay: Record<
  InternalTransferMethodEnum,
  InternalTransferMethodDisplayEnum
> = {
  [InternalTransferMethodEnum.SHARES]: InternalTransferMethodDisplayEnum.SHARES,
  [InternalTransferMethodEnum.PERCENT]: InternalTransferMethodDisplayEnum.PERCENT,
  [InternalTransferMethodEnum.DOLLARS]: InternalTransferMethodDisplayEnum.DOLLARS,
  [InternalTransferMethodEnum.UNKNOWN]: InternalTransferMethodDisplayEnum.UNKNOWN,
};
